import React from 'react';
import { useDispatch } from 'react-redux';
import elementsActions from 'actions/editor/elements';
import GeneratedMultipleChoice from './GeneratedMultipleChoice';
import ActionButtons from './ActionButtons';
import { GENERATED_QUESTION_OPTIONS } from '../constants';

const MultipleChoiceBody = ({
  dismissCallback,
  position,
  selectedQuestionType,
  selectedAIOption,
  generatedOptions,
  setGeneratedOptions,
  generate,
  questionText,
  back,
  sendLLMFeedback,
}) => {
  const dispatch = useDispatch();

  const formatAnswers = generatedOption => {
    const { options, correct_options: correctOptions } = generatedOption;
    const allOptions = [...new Set([...options, ...correctOptions])];

    const formattedChoices = allOptions.map((choice, index) => {
      let formattedChoice = choice;
      if (correctOptions.includes(choice)) {
        formattedChoice += '*';
      }

      if (index !== allOptions.length - 1) {
        formattedChoice += '\n';
      }

      return formattedChoice;
    });

    return formattedChoices.join('');
  };

  const addQuestionToSection = (idx, subject, rawChoices) => {
    setGeneratedOptions(prevOptions =>
      prevOptions.map((option, i) => {
        return idx !== i ? option : { ...option, added: true };
      }),
    );

    const numQuestionsAdded = generatedOptions.filter(op => op.added).length;

    dispatch(
      elementsActions.createAIGeneratedElement(
        selectedQuestionType,
        position + numQuestionsAdded,
        {
          subject,
          raw_choices: rawChoices,
        },
      ),
    ).then(() => {
      if (selectedAIOption === GENERATED_QUESTION_OPTIONS.ANSWERS_ONLY) {
        dismissCallback();
      }
    });
  };

  const renderAnswersOnly = () => {
    const { question, added } = generatedOptions[0];
    const formattedChoices = formatAnswers(generatedOptions[0]);
    return (
      <GeneratedMultipleChoice
        index={0}
        question={question}
        added={added}
        answerChoices={formattedChoices}
        addQuestionToSection={addQuestionToSection}
        back={back}
        tryAgain={generate}
        answersOnly
        sendLLMFeedback={sendLLMFeedback}
      />
    );
  };

  if (selectedAIOption === GENERATED_QUESTION_OPTIONS.ANSWERS_ONLY) {
    return renderAnswersOnly();
  }

  return (
    <>
      {selectedAIOption === GENERATED_QUESTION_OPTIONS.QUESTION_AND_ANSWERS &&
        generatedOptions.map((option, index) => {
          const { question, added } = option;
          const formattedChoices = formatAnswers(option);
          return (
            <GeneratedMultipleChoice
              key={question}
              index={index}
              question={question}
              added={added}
              answerChoices={formattedChoices}
              addQuestionToSection={addQuestionToSection}
              sendLLMFeedback={sendLLMFeedback}
            />
          );
        })}
      <ActionButtons
        back={back}
        tryAgain={() => generate(questionText)}
        primaryAction={dismissCallback}
        primaryActionText={t('lessons.editor.element_assistant.actions.done')}
      />
    </>
  );
};

export default MultipleChoiceBody;
